import { isMacOs } from 'react-device-detect';

export const calcTimeGapToNowInKorean = (date: Date) => {
  const current = new Date();
  const currentUTCTime = current.getTime() + current.getTimezoneOffset() * 60 * 1000;

  const timeGap = currentUTCTime - date.getTime();
  const seconds = timeGap / 1000;

  if (seconds < 60) return `${Math.floor(seconds)}초 전`;

  const minutes = seconds / 60;
  if (minutes < 60) return `${Math.floor(minutes)}분 전`;

  const hours = minutes / 60;
  if (hours < 24) return `${Math.floor(hours)}시간 전`;

  const days = hours / 24;
  if (days < 7) return `${Math.floor(days)}일 전`;

  const weeks = days / 7;
  if (weeks < 5) return `${Math.floor(weeks)}주 전`;

  const months = days / 30;
  if (months < 12) return `${Math.floor(months)}달 전`;

  const years = days / 365;
  return `${Math.floor(years)}년 전`;
};

export const checkImageFile = (file: File, option?: { maxSize: number }) => {
  const { type, size } = file;

  if (type !== 'image/jpg' && type !== 'image/jpeg' && type !== 'image/png') return false;
  if (option?.maxSize && size > option.maxSize) return false;

  return true;
};

export const copyClipboard = (text: string) => {
  const textarea = document.createElement('textarea');

  textarea.value = text;
  textarea.style.width = '0px';
  textarea.style.height = '0px';
  textarea.style.opacity = '0';
  textarea.style.position = 'fixed';
  textarea.style.zIndex = '-9999';
  textarea.style.top = '0px';
  textarea.style.left = '0px';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
};

export const inputValidation = (value: string, option?: { type: 'number' | 'int'; min?: number; max?: number }) => {
  if (option?.type === 'number' || option?.type === 'int') {
    const numValue = Number(value);

    if (isNaN(numValue)) return false;
    if (option.min !== undefined && numValue < option.min) return false;
    if (option.max !== undefined && numValue > option.max) return false;
    if (option.type === 'int' && value.includes('.')) return false;
  }

  return true;
};

export const code2LargeAlphabetString = (code: number) => {
  const largeAcode = 65;
  const largeZcode = 90;
  const total = largeZcode - largeAcode + 1;

  let result = [] as string[];

  do {
    const mod = code % total;
    const char = String.fromCharCode(mod + largeAcode);
    result.push(char);

    code = Math.floor(code / total) - 1;
  } while (code >= 0);

  result.reverse();
  return result.join('');
};

export const deepCopy = <T>(target: T): T => {
  return JSON.parse(JSON.stringify(target));
};

export const getCommandKeyName = (keyName: string) => {
  const commandKey = isMacOs ? '⌘' : 'Ctrl';
  return `${commandKey}+${keyName}`;
};
